import { track } from '../analytics'
import { collectionOf, routeOf } from './readMeterPaths'

// Estimates billed Firestore reads per collection and reports them to GA4 as
// `firestore_reads`, one event per collection, attributed to the route they
// happened on. Flushed on route change and when the app is hidden, so a
// session's reads land even if it never navigates. Feeds the reads-per-user
// number in plans/firestore-cost-reduction.md (Phase E).
//
// It's an upper bound: a listener's first server snapshot is counted in full,
// which is exact for a cold or memory cache and for a resume after >30 min,
// but over-counts a quick re-listen that Firestore bills only for changes.
const counts = new Map<string, number>()
let route = '/'

export function meterReads(path: string, n: number): void {
  if (n <= 0) return
  const collection = collectionOf(path)
  counts.set(collection, (counts.get(collection) ?? 0) + n)
}

export function setReadMeterRoute(pathname: string): void {
  const next = routeOf(pathname)
  if (next === route) return
  flushReads()
  route = next
}

export function flushReads(): void {
  for (const [collection, readCount] of counts) {
    track('firestore_reads', { target: collection, surface: route, read_count: readCount })
  }
  counts.clear()
}

if (typeof document !== 'undefined') {
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'hidden') flushReads()
  })
}
